import {Action} from '@ngrx/store';
import {SubscriptionI} from '../models/subscription-i';
import {type} from '../utilities/type';

export const currentSubscriptionActionTypes = {
  LOAD: type('[Current SubscriptionI] Load'),
  LOAD_SUCCESS: type('[Current SubscriptionI] Load Success'),
  LOAD_FAIL: type('[Current SubscriptionI] Load Fail')
};

export class LoadCurrentSubscriptionAction implements Action {
  readonly type = currentSubscriptionActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadCurrentSubscriptionSuccessAction implements Action {
  readonly type = currentSubscriptionActionTypes.LOAD_SUCCESS;
  constructor(public payload?: SubscriptionI) {}
}

export class LoadCurrentSubscriptionFailAction implements Action {
  readonly type = currentSubscriptionActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
